<h2>[{{registration.id}}] {{registration.description}}</h2>

<app-info-box message="Przedmioty, na które można się zapisać, są podzielone na grupy,
  żeby ułatwić ich wyszukiwanie. Na poniższej liście znajdują się grupy zawierające co
  najmniej jeden przedmiot z wybranej rejestracji. Wybierz grupę, aby przejść do wykazu przedmiotów tej grupy.
" i18n-message></app-info-box>

<a [routerLink]="['../..']" i18n>powrót</a>

<table class="grey">
  <thead>
  <tr class="headnote">
    <td i18n>Lp.</td>
    <td i18n>Kod grupy</td>
    <td i18n>Nazwa grupy przedmiotów</td>
  </tr>
  </thead>
  <tbody class="autostring">
  <tr *ngFor="let group of registration.coursesGroups; let i = index">
    <td>{{i + 1}}</td>
    <td>{{group.id}}</td>
    <td>
      <a [routerLink]="[group.id]">
        {{group.description}}
      </a>
    </td>
  </tr>
  <tr>
    <td colspan="3">
      <a i18n [routerLink]="[allId]">wszystkie przedmioty</a> </td>
  </tr>
  </tbody>
</table>

<a [routerLink]="['../..']" i18n>powrót</a>
